<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="9" :sm="6">
            <el-form-item label="日期范围:">
              <el-date-picker
                v-model="daterange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
            <el-form-item label="巡查项目:">
              <el-select v-model="table.where.scopeId" placeholder="请选择巡查项目" class="ele-block" clearable @change="changeScope">
                <el-option v-for="item in allscopeData" :key="item.id" :label="item.info" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="6">
            <el-form-item v-if="allrangeData" label="巡查范围:">
              <el-cascader
                v-model="table.where.rangeId"
                ref="range"
                :options="allrangeData"
                :props="{
                  checkStrictly: true,
                  expandTrigger: 'hover',
                  emitPath: false,
                  value: 'id',
                  label: 'info',
                }"
                clearable
                filterable
                @change="getcheckRange"
              />
            </el-form-item>
            <el-form-item v-if="allresultData" label="巡查结果:">
              <el-select v-model="table.where.resultId" placeholder="请选择巡查结果" class="ele-block" clearable>
                <el-option v-for="item in allresultData" :key="item.id" :label="item.info" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="6">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
              <el-button
                @click="
                  (table.where = {
                    startTime: $util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
                    endTime: $util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
                  }) && $refs.table.reload()
                "
                >重置</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="ele-table-tool ele-table-tool-default">
        <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出报表</el-button>
      </div>
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column header-align="center" prop="scopeInfo" align="center" label="巡查项目" />
          <el-table-column header-align="center" prop="rangeInfo" align="center" label="巡查范围" />
          <el-table-column header-align="center" prop="resultInfo" align="center" label="巡查结果" />
          <el-table-column header-align="center" align="center" label="分值" width="60">
            <template #default="{ row }">
              {{
                row.resultSubtractState == 1
                  ? '+' + row.resultSubtractPoints
                  : row.resultSubtractState == 2
                  ? '-' + row.resultSubtractPoints
                  : row.resultSubtractState == 0
                  ? row.resultSubtractPoints
                  : ''
              }}
            </template>
          </el-table-column>
          <el-table-column label="照片" show-overflow-tooltip :fit="true" align="center" width="80">
            <template #default="{ row }">
              <el-tag :type="row.photo ? 'success' : 'info'" @click="proviewImage(row)">{{ row.photo ? '预览' : '暂无' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column header-align="center" prop="createName" align="center" label="巡查教师" width="90" />
          <el-table-column header-align="center" prop="remark" align="center" label="备注" />
          <el-table-column header-align="center" align="center" label="巡查时间">
            <template #default="{ row }">{{ row.createTime | toDateString }}</template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!-- 图片预览弹窗 -->
      <el-dialog title="预览图片" :visible.sync="showImage" width="30%" @close="photo = []" :destroy-on-close="true" :lock-scroll="false">
        <div v-if="photo.length > 0" style="display: flex">
          <el-image v-for="(item, index) in photo" :key="index" :src="item" alt="" style="width: 33%; height: auto" fit="contain" />
        </div>

        <div v-else>暂无图片数据</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showImage = false">取 消</el-button>
          <el-button type="primary" @click="showImage = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import { getSearchInfoExcel, getInfoAllScope, getInfoAllRange, getInfoAllResult } from '@/config/api';

  export default {
    name: 'Result',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/schoolSearch/getSearchInfoList',
          where: {
            startTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'),
            endTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59'),
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [this.$util.toDateString(new Date(), 'yyyy-MM-dd 00:00:00'), this.$util.toDateString(new Date(), 'yyyy-MM-dd 23:59:59')],
        allscopeData: [], //巡查项目数据
        allrangeData: null, //巡查范围数据
        allresultData: null, //巡查结果设置数据
        scopeId: null,
        rangeId: null,
        photo: [],
        showImage: false,
      };
    },
    mounted() {
      this.queryAllscope(); //获取所有巡查项目
    },
    methods: {
      // 获取所有巡查项目
      queryAllscope() {
        getInfoAllScope().then((res) => {
          if (res.data.resCode == 200) {
            this.allscopeData = res.data.data;
          }
        });
      },
      // 选中巡查项目时获取巡查范围数据，并展示巡查范围
      changeScope(scopeId) {
        this.scopeId = scopeId;
        let data = { scopeId: this.scopeId };
        getInfoAllRange(data).then((res) => {
          if (res.data.resCode == 200) {
            if (res.data.data == '') {
              this.allrangeData = null;
              this.allresultData = null;
              this.table.where.rangeId = null;
              this.table.where.resultId = null;
            } else {
              this.allrangeData = res.data.data;
            }
          }
        });
      },
      // 选中巡查范围数据时获取巡查结果，并展示巡查结果
      getcheckRange(rangeId) {
        this.rangeId = rangeId;
        let data = {
          scopeId: this.scopeId,
          rangeId: this.rangeId,
        };
        getInfoAllResult(data).then((res) => {
          if (res.data.resCode == 200) {
            if (res.data.data == '') {
              this.allresultData = null;
              this.table.where.resultId = null;
            } else {
              this.allresultData = res.data.data;
            }
          }
        });
      },
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd HH:mm:ss');
          this.table.where.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd HH:mm:ss');
        } else {
          this.table.where.startTime = null;
          this.table.where.endTime = null;
        }
      },
      // 导出数据
      exportData() {
        let data = {};
        if (this.daterange) {
          data.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd HH:mm:ss');
          data.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd HH:mm:ss');
        } else {
          data.startTime = null;
          data.endTime = null;
        }
        getSearchInfoExcel(data).then((res) => {
          if (res.data.resCode == 200) {
            window.open(res.data.data);
          } else {
            this.$message({ type: 'info', message: '下载失败' });
          }
        });
      },
      // 预览照片
      proviewImage(row) {
        if (row.photo != '') {
          this.showImage = true;
          this.photo = row.photo.split(',');
        } else {
          this.photo = [];
        }
      },
    },
  };
</script>

<style scoped></style>
